'use strict';

// Class definition
var KTTimelineWidget4 = (function () {
  // Private methods
  // Day timeline
  const initTimelineDay = () => {
    // Detect element
    const element = document.querySelector('#kt_timeline_widget_4_1');
    if (!element) {
      return;
    }

    if (element.innerHTML) {
      return;
    }

    // Set variables
    var now = Date.now();
    var rootImagePath = element.getAttribute(
      'data-kt-timeline-widget-4-image-root',
    );

    // Build vis-timeline datasets
    var groups = new vis.DataSet([
      {
        id: 'research',
        content: 'Research',
        order: 1,
      },
      {
        id: 'qa',
        content: 'Phase 2.6 QA',
        order: 2,
      },
      {
        id: 'ui',
        content: 'UI Design',
        order: 3,
      },
      {
        id: 'dev',
        content: 'Development',
        order: 4,
      },
    ]);

    var items = new vis.DataSet([
      {
        id: 1,
        group: 'research',
        start: now,
        end: moment(now).add(1.5, 'hours'),
        content: 'Meeting',
        progress: '60%',
        color: 'primary',
        users: ['avatars/300-6.jpg', 'avatars/300-1.jpg'],
      },
      {
        id: 2,
        group: 'qa',
        start: moment(now).add(1, 'hours'),
        end: moment(now).add(2, 'hours'),
        content: 'Testing',
        progress: '47%',
        color: 'success',
        users: ['avatars/300-2.jpg'],
      },
      {
        id: 3,
        group: 'ui',
        start: moment(now).add(30, 'minutes'),
        end: moment(now).add(2.5, 'hours'),
        content: 'Landing page',
        progress: '55%',
        color: 'danger',
        users: ['avatars/300-5.jpg', 'avatars/300-20.jpg'],
      },
      {
        id: 4,
        group: 'dev',
        start: moment(now).add(1.5, 'hours'),
        end: moment(now).add(3, 'hours'),
        content: 'Products module',
        progress: '75%',
        color: 'info',
        users: [
          'avatars/300-23.jpg',
          'avatars/300-12.jpg',
          'avatars/300-9.jpg',
        ],
      },
    ]);

    // Set vis-timeline options
    var options = {
      zoomable: false,
      moveable: false,
      selectable: false,
      // More options https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      margin: {
        item: {
          horizontal: 10,
          vertical: 35,
        },
      },

      // Remove current time line --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      showCurrentTime: false,

      // Whitelist specified tags and attributes from template --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      xss: {
        disabled: false,
        filterOptions: {
          whiteList: {
            div: ['class', 'style'],
            img: ['data-kt-timeline-avatar-src', 'alt'],
            a: ['href', 'class'],
          },
        },
      },
      // specify a template for the items
      template: function (item) {
        // Build users group
        const users = item.users;
        let userTemplate = '';
        users.forEach((user) => {
          userTemplate += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${rootImagePath + user}" alt="" /></div>`;
        });

        return `<div class="rounded-pill bg-light-${item.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">
                    <div class="position-absolute rounded-pill d-block bg-${item.color} start-0 top-0 h-100 z-index-1" style="width: ${item.progress};"></div>

                    <div class="d-flex align-items-center position-relative z-index-2">
                        <div class="symbol-group symbol-hover flex-nowrap me-3">
                            ${userTemplate}
                        </div>

                        <a href="#" class="fw-bold text-white text-hover-dark">${item.content}</a>
                    </div>

                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">
                        ${item.progress}
                    </div>
                </div>
                `;
      },

      // Remove block ui on initial draw
      onInitialDrawComplete: function () {
        handleAvatarPath();

        const target = element.closest(
          '[data-kt-timeline-widget-4-blockui="true"]',
        );
        const blockUI = KTBlockUI.getInstance(target);

        if (blockUI.isBlocked()) {
          setTimeout(() => {
            blockUI.release();
          }, 1000);
        }
      },
    };

    // Init vis-timeline
    const timeline = new vis.Timeline(element, items, groups, options);

    // Prevent infinite loop draws
    timeline.on('currentTimeTick', () => {
      // After fired the first time we un-subscribed
      timeline.off('currentTimeTick');
    });
  };

  // Week timeline
  const initTimelineWeek = () => {
    // Detect element
    const element = document.querySelector('#kt_timeline_widget_4_2');
    if (!element) {
      return;
    }

    if (element.innerHTML) {
      return;
    }

    // Set variables
    var now = Date.now();
    var rootImagePath = element.getAttribute(
      'data-kt-timeline-widget-4-image-root',
    );

    // Build vis-timeline datasets
    var groups = new vis.DataSet([
      {
        id: 1,
        content: 'Research',
        order: 1,
      },
      {
        id: 2,
        content: 'Phase 2.6 QA',
        order: 2,
      },
      {
        id: 3,
        content: 'UI Design',
        order: 3,
      },
      {
        id: 4,
        content: 'Development',
        order: 4,
      },
    ]);

    var items = new vis.DataSet([
      {
        id: 1,
        group: 1,
        start: now,
        end: moment(now).add(7, 'days'),
        content: 'Framework',
        progress: '71%',
        color: 'primary',
        users: ['avatars/300-6.jpg', 'avatars/300-1.jpg'],
      },
      {
        id: 2,
        group: 2,
        start: moment(now).add(7, 'days'),
        end: moment(now).add(14, 'days'),
        content: 'Accessibility',
        progress: '84%',
        color: 'success',
        users: ['avatars/300-2.jpg'],
      },
      {
        id: 3,
        group: 3,
        start: moment(now).add(3, 'days'),
        end: moment(now).add(20, 'days'),
        content: 'Microsites',
        progress: '69%',
        color: 'danger',
        users: ['avatars/300-5.jpg', 'avatars/300-20.jpg'],
      },
      {
        id: 4,
        group: 4,
        start: moment(now).add(10, 'days'),
        end: moment(now).add(21, 'days'),
        content: 'Deployment',
        progress: '74%',
        color: 'info',
        users: [
          'avatars/300-23.jpg',
          'avatars/300-12.jpg',
          'avatars/300-9.jpg',
        ],
      },
    ]);

    // Set vis-timeline options
    var options = {
      zoomable: false,
      moveable: false,
      selectable: false,

      // More options https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      margin: {
        item: {
          horizontal: 10,
          vertical: 35,
        },
      },

      // Remove current time line --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      showCurrentTime: false,

      // Whitelist specified tags and attributes from template --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      xss: {
        disabled: false,
        filterOptions: {
          whiteList: {
            div: ['class', 'style'],
            img: ['data-kt-timeline-avatar-src', 'alt'],
            a: ['href', 'class'],
          },
        },
      },
      // specify a template for the items
      template: function (item) {
        // Build users group
        const users = item.users;
        let userTemplate = '';
        users.forEach((user) => {
          userTemplate += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${rootImagePath + user}" alt="" /></div>`;
        });

        return `<div class="rounded-pill bg-light-${item.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">
                    <div class="position-absolute rounded-pill d-block bg-${item.color} start-0 top-0 h-100 z-index-1" style="width: ${item.progress};"></div>

                    <div class="d-flex align-items-center position-relative z-index-2">
                        <div class="symbol-group symbol-hover flex-nowrap me-3">
                            ${userTemplate}
                        </div>

                        <a href="#" class="fw-bold text-white text-hover-dark">${item.content}</a>
                    </div>

                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">
                        ${item.progress}
                    </div>
                </div>
                `;
      },

      // Remove block ui on initial draw
      onInitialDrawComplete: function () {
        handleAvatarPath();

        const target = element.closest(
          '[data-kt-timeline-widget-4-blockui="true"]',
        );
        const blockUI = KTBlockUI.getInstance(target);

        if (blockUI.isBlocked()) {
          setTimeout(() => {
            blockUI.release();
          }, 1000);
        }
      },
    };

    // Init vis-timeline
    const timeline = new vis.Timeline(element, items, groups, options);

    // Prevent infinite loop draws
    timeline.on('currentTimeTick', () => {
      // After fired the first time we un-subscribed
      timeline.off('currentTimeTick');
    });
  };

  // Month timeline
  const initTimelineMonth = () => {
    // Detect element
    const element = document.querySelector('#kt_timeline_widget_4_3');
    if (!element) {
      return;
    }

    if (element.innerHTML) {
      return;
    }

    // Set variables
    var now = Date.now();
    var rootImagePath = element.getAttribute(
      'data-kt-timeline-widget-4-image-root',
    );

    // Build vis-timeline datasets
    var groups = new vis.DataSet([
      {
        id: 'research',
        content: 'Research',
        order: 1,
      },
      {
        id: 'qa',
        content: 'Phase 2.6 QA',
        order: 2,
      },
      {
        id: 'ui',
        content: 'UI Design',
        order: 3,
      },
      {
        id: 'dev',
        content: 'Development',
        order: 4,
      },
    ]);

    var items = new vis.DataSet([
      {
        id: 1,
        group: 'research',
        start: now,
        end: moment(now).add(2, 'months'),
        content: 'Tags',
        progress: '79%',
        color: 'primary',
        users: ['avatars/300-6.jpg', 'avatars/300-1.jpg'],
      },
      {
        id: 2,
        group: 'qa',
        start: moment(now).add(0.5, 'months'),
        end: moment(now).add(5, 'months'),
        content: 'Testing',
        progress: '64%',
        color: 'success',
        users: ['avatars/300-2.jpg'],
      },
      {
        id: 3,
        group: 'ui',
        start: moment(now).add(2, 'months'),
        end: moment(now).add(6.5, 'months'),
        content: 'Media',
        progress: '82%',
        color: 'danger',
        users: ['avatars/300-5.jpg', 'avatars/300-20.jpg'],
      },
      {
        id: 4,
        group: 'dev',
        start: moment(now).add(4, 'months'),
        end: moment(now).add(7, 'months'),
        content: 'Plugins',
        progress: '58%',
        color: 'info',
        users: [
          'avatars/300-23.jpg',
          'avatars/300-12.jpg',
          'avatars/300-9.jpg',
        ],
      },
    ]);

    // Set vis-timeline options
    var options = {
      zoomable: false,
      moveable: false,
      selectable: false,

      // More options https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      margin: {
        item: {
          horizontal: 10,
          vertical: 35,
        },
      },

      // Remove current time line --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      showCurrentTime: false,

      // Whitelist specified tags and attributes from template --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      xss: {
        disabled: false,
        filterOptions: {
          whiteList: {
            div: ['class', 'style'],
            img: ['data-kt-timeline-avatar-src', 'alt'],
            a: ['href', 'class'],
          },
        },
      },
      // specify a template for the items
      template: function (item) {
        // Build users group
        const users = item.users;
        let userTemplate = '';
        users.forEach((user) => {
          userTemplate += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${rootImagePath + user}" alt="" /></div>`;
        });

        return `<div class="rounded-pill bg-light-${item.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">
                    <div class="position-absolute rounded-pill d-block bg-${item.color} start-0 top-0 h-100 z-index-1" style="width: ${item.progress};"></div>

                    <div class="d-flex align-items-center position-relative z-index-2">
                        <div class="symbol-group symbol-hover flex-nowrap me-3">
                            ${userTemplate}
                        </div>

                        <a href="#" class="fw-bold text-white text-hover-dark">${item.content}</a>
                    </div>

                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">
                        ${item.progress}
                    </div>
                </div>
                `;
      },

      // Remove block ui on initial draw
      onInitialDrawComplete: function () {
        handleAvatarPath();

        const target = element.closest(
          '[data-kt-timeline-widget-4-blockui="true"]',
        );
        const blockUI = KTBlockUI.getInstance(target);

        if (blockUI.isBlocked()) {
          setTimeout(() => {
            blockUI.release();
          }, 1000);
        }
      },
    };

    // Init vis-timeline
    const timeline = new vis.Timeline(element, items, groups, options);

    // Prevent infinite loop draws
    timeline.on('currentTimeTick', () => {
      // After fired the first time we un-subscribed
      timeline.off('currentTimeTick');
    });
  };

  // 2022 timeline
  const initTimeline2022 = () => {
    // Detect element
    const element = document.querySelector('#kt_timeline_widget_4_4');
    if (!element) {
      return;
    }

    if (element.innerHTML) {
      return;
    }

    // Set variables
    var now = Date.now();
    var rootImagePath = element.getAttribute(
      'data-kt-timeline-widget-4-image-root',
    );

    // Build vis-timeline datasets
    var groups = new vis.DataSet([
      {
        id: 'research',
        content: 'Research',
        order: 1,
      },
      {
        id: 'qa',
        content: 'Phase 2.6 QA',
        order: 2,
      },
      {
        id: 'ui',
        content: 'UI Design',
        order: 3,
      },
      {
        id: 'dev',
        content: 'Development',
        order: 4,
      },
    ]);

    var items = new vis.DataSet([
      {
        id: 1,
        group: 'research',
        start: now,
        end: moment(now).add(2, 'months'),
        content: 'Tags',
        progress: '51%',
        color: 'primary',
        users: ['avatars/300-7.jpg', 'avatars/300-2.jpg'],
      },
      {
        id: 2,
        group: 'qa',
        start: moment(now).add(0.5, 'months'),
        end: moment(now).add(5, 'months'),
        content: 'Testing',
        progress: '64%',
        color: 'success',
        users: ['avatars/300-2.jpg'],
      },
      {
        id: 3,
        group: 'ui',
        start: moment(now).add(2, 'months'),
        end: moment(now).add(6.5, 'months'),
        content: 'Media',
        progress: '54%',
        color: 'danger',
        users: ['avatars/300-5.jpg', 'avatars/300-21.jpg'],
      },
      {
        id: 4,
        group: 'dev',
        start: moment(now).add(4, 'months'),
        end: moment(now).add(7, 'months'),
        content: 'Plugins',
        progress: '348%',
        color: 'info',
        users: [
          'avatars/300-3.jpg',
          'avatars/300-11.jpg',
          'avatars/300-13.jpg',
        ],
      },
    ]);

    // Set vis-timeline options
    var options = {
      zoomable: false,
      moveable: false,
      selectable: false,

      // More options https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      margin: {
        item: {
          horizontal: 10,
          vertical: 35,
        },
      },

      // Remove current time line --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      showCurrentTime: false,

      // Whitelist specified tags and attributes from template --- more info: https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
      xss: {
        disabled: false,
        filterOptions: {
          whiteList: {
            div: ['class', 'style'],
            img: ['data-kt-timeline-avatar-src', 'alt'],
            a: ['href', 'class'],
          },
        },
      },
      // specify a template for the items
      template: function (item) {
        // Build users group
        const users = item.users;
        let userTemplate = '';
        users.forEach((user) => {
          userTemplate += `<div class="symbol symbol-circle symbol-25px"><img data-kt-timeline-avatar-src="${rootImagePath + user}" alt="" /></div>`;
        });

        return `<div class="rounded-pill bg-light-${item.color} d-flex align-items-center position-relative h-40px w-100 p-2 overflow-hidden">
                    <div class="position-absolute rounded-pill d-block bg-${item.color} start-0 top-0 h-100 z-index-1" style="width: ${item.progress};"></div>

                    <div class="d-flex align-items-center position-relative z-index-2">
                        <div class="symbol-group symbol-hover flex-nowrap me-3">
                            ${userTemplate}
                        </div>

                        <a href="#" class="fw-bold text-white text-hover-dark">${item.content}</a>
                    </div>

                    <div class="d-flex flex-center bg-body rounded-pill fs-7 fw-bolder ms-auto h-100 px-3 position-relative z-index-2">
                        ${item.progress}
                    </div>
                </div>
                `;
      },

      // Remove block ui on initial draw
      onInitialDrawComplete: function () {
        handleAvatarPath();

        const target = element.closest(
          '[data-kt-timeline-widget-4-blockui="true"]',
        );
        const blockUI = KTBlockUI.getInstance(target);

        if (blockUI.isBlocked()) {
          setTimeout(() => {
            blockUI.release();
          }, 1000);
        }
      },
    };

    // Init vis-timeline
    const timeline = new vis.Timeline(element, items, groups, options);

    // Prevent infinite loop draws
    timeline.on('currentTimeTick', () => {
      // After fired the first time we un-subscribed
      timeline.off('currentTimeTick');
    });
  };
  // Handle BlockUI
  const handleBlockUI = () => {
    // Select block ui elements
    const elements = document.querySelectorAll(
      '[data-kt-timeline-widget-4-blockui="true"]',
    );

    // Init block ui
    elements.forEach((element) => {
      const blockUI = new KTBlockUI(element, {
        overlayClass: 'bg-body',
      });

      blockUI.block();
    });
  };

  // Handle tabs visibility
  const tabsVisibility = () => {
    const tabs = document.querySelectorAll('[data-kt-timeline-widget-4="tab"]');

    tabs.forEach((tab) => {
      tab.addEventListener('shown.bs.tab', (e) => {
        // Week tab
        if (tab.getAttribute('href') === '#kt_timeline_widget_4_tab_week') {
          initTimelineWeek();
        }

        // Month tab
        if (tab.getAttribute('href') === '#kt_timeline_widget_4_tab_month') {
          initTimelineMonth();
        }

        // 2022 tab
        if (tab.getAttribute('href') === '#kt_timeline_widget_4_tab_2022') {
          initTimeline2022();
        }
      });
    });
  };

  // Handle avatar path conflict
  const handleAvatarPath = () => {
    const avatars = document.querySelectorAll('[data-kt-timeline-avatar-src]');

    if (!avatars) {
      return;
    }

    avatars.forEach((avatar) => {
      avatar.setAttribute(
        'src',
        avatar.getAttribute('data-kt-timeline-avatar-src'),
      );
      avatar.removeAttribute('data-kt-timeline-avatar-src');
    });
  };

  // Public methods
  return {
    init: function () {
      initTimelineDay();
      handleBlockUI();
      tabsVisibility();
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTTimelineWidget4;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTTimelineWidget4.init();
});
